import { useState } from 'react'
import { Link, useRouterState } from '@tanstack/react-router'
import { Menu } from 'lucide-react'
import { Drawer } from '@shared/design-system/ui'
import { useSession } from '@shared/lib/auth/session-store'
import { useAdminRuntimeCapabilities } from '@features/admin/api/admin.api'
import {
  bottomNavItems,
  canAccessNavItem,
  isNavItemActive,
  mobileMoreNavItems,
  navItemCapabilityMet,
} from './nav-items'
import {
  bottomNav,
  bottomNavButton,
  bottomNavItem,
  mobileMoreItem,
  mobileMoreList,
} from './AppShell.css'

export function BottomNav() {
  const [moreOpen, setMoreOpen] = useState(false)
  const user = useSession((state) => state.user)
  const capabilities = useAdminRuntimeCapabilities()
  const visibleItems = bottomNavItems.filter(
    (item) => canAccessNavItem(item, user) && navItemCapabilityMet(item, capabilities.data),
  )
  const visibleMoreItems = mobileMoreNavItems.filter(
    (item) => canAccessNavItem(item, user) && navItemCapabilityMet(item, capabilities.data),
  )
  const pathname = useRouterState({ select: (state) => state.location.pathname })
  const moreActive = visibleMoreItems.some((item) => isNavItemActive(item, pathname))

  return (
    <>
      <nav className={bottomNav} aria-label="Navegação principal" data-testid="bottom-nav">
        {visibleItems.map((item) => (
          <Link key={item.to} to={item.to} className={bottomNavItem}>
            <item.icon size={20} />
            <span>{item.label}</span>
          </Link>
        ))}
        {visibleMoreItems.length > 0 ? (
          <button
            type="button"
            className={`${bottomNavItem} ${bottomNavButton}`}
            data-status={moreActive ? 'active' : undefined}
            aria-haspopup="dialog"
            aria-expanded={moreOpen}
            onClick={() => setMoreOpen(true)}
          >
            <Menu size={20} />
            <span>Mais</span>
          </button>
        ) : null}
      </nav>
      <Drawer
        open={moreOpen}
        onClose={() => setMoreOpen(false)}
        title="Mais áreas"
        description="Acesse as demais áreas permitidas para seu perfil."
        size="compact"
        variant="navigation"
        placement="bottom"
      >
        <nav className={mobileMoreList} aria-label="Outras áreas da gestão">
          {visibleMoreItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={mobileMoreItem}
              onClick={() => setMoreOpen(false)}
            >
              <item.icon size={19} />
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>
      </Drawer>
    </>
  )
}
